import React, { useState } from "react";
import { useStyles } from "./styles";
import { Typography, TextField, InputAdornment } from "@material-ui/core";
import WarehouseDetailsIcon from "./icons/WarehouseDetailsIcon";
import EmailIcon from "./icons/EmailIcon";
import { useAppContext } from "src/providers/AppProvider";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FormControl } from "@material-ui/core";
import { InputLabel } from "@material-ui/core";
import { OutlinedInput } from "@material-ui/core";
import ContactPersonIcon from "./icons/ContactPersonIcon";
import Modal from "src/components/Modal";
import WarehouseSelect from "./components/WarehouseSelect";
import { Grid } from "@material-ui/core";
import { Warehouse } from "src/types";
import { requestPost } from "src/utils/crud";
import { FormHelperText } from "@material-ui/core";
import { emailPattern } from "src/utils/constants";
import { useForm, FormProvider, Controller } from "react-hook-form";
import Success from "./Success";
import { CancelButton, SaveButton } from "src/components/Buttons";
import PhoneInputField from "src/components/PhoneInput/";
import { WarehousesDetailsType } from "../../type";
import { useParams } from "react-router-dom";

interface Props extends Partial<Warehouse> {
  firstName: string;
  lastName: string;
  warehouseId: string;
}

const CreateSeller: React.FC = () => {
  const [status, setStatus] = useState("");
  const { warehousesID } = useParams<WarehousesDetailsType>();
  const methods = useForm<Props>({
    mode: "all",
  });
  const {
    handleSubmit,
    register,
    errors,
    formState,
    setError,
    clearErrors,
    setValue,
    control,
  } = methods;
  const classes = useStyles();
  const {
    state: {
      modals: { sellersModal },
    },
    callAppAPI: { toggleModal },
  } = useAppContext();

  const { t } = useTranslation("sellers");

  const handleModal = useCallback(() => {
    toggleModal({ id: "sellersModal", status: false });
    setStatus("");
  }, []);

  const onSubmit = useCallback((data: Props) => {
    (async () => {
      const res = await requestPost<Props>("Sellers", {
        ...data,
        name: `${data.firstName} ${data.lastName}`,
        warehouseId: warehousesID,
      });
      setStatus(`${res.status}`);
    })();
  }, []);

  if (status === "204") {
    return (
      <Modal isOpen={sellersModal}>
        <Success onClose={handleModal} />
      </Modal>
    );
  }
  const onErrorHandler = (isError: boolean) => {
    isError
      ? setError("mobilePhone", {
          type: "manual",
        })
      : clearErrors("mobilePhone");
  };
  return (
    <Modal isOpen={sellersModal} onClose={handleModal}>
      <Grid container justify="center">
        <Grid item>
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Typography variant="h3">{t("form.title")}</Typography>
              <div className={classes.fieldGroup}>
                <div className={classes.titleWrapper}>
                  <WarehouseDetailsIcon />
                  <Typography variant="h4" className={classes.fieldTitle}>
                    {t("form.warehouse_details")}
                  </Typography>
                </div>
                <WarehouseSelect />
              </div>
              <div className={classes.fieldGroup}>
                <div className={classes.titleWrapper}>
                  <ContactPersonIcon />
                  <Typography variant="h4" className={classes.fieldTitle}>
                    Seller
                  </Typography>
                </div>
                <TextField
                  required
                  fullWidth
                  error={!!errors.firstName}
                  name="firstName"
                  label={t("form.first_name")}
                  variant="outlined"
                  inputRef={register({
                    required: "Required",
                  })}
                />
                <TextField
                  required
                  fullWidth
                  error={!!errors.lastName}
                  name="lastName"
                  inputRef={register({
                    required: "Required",
                  })}
                  label={t("form.last_name")}
                  variant="outlined"
                />
                <FormControl
                  error={!!errors.email}
                  required
                  fullWidth
                  className={classes.textField}
                  variant="outlined"
                >
                  <InputLabel htmlFor="email">{t("form.email")}</InputLabel>
                  <OutlinedInput
                    id="email"
                    type="email"
                    name="email"
                    fullWidth
                    inputRef={register({
                      required: "Required",
                      pattern: emailPattern,
                    })}
                    endAdornment={
                      <InputAdornment position="end">
                        <EmailIcon />
                      </InputAdornment>
                    }
                    labelWidth={140}
                  />
                  {!!errors.email && (
                    <FormHelperText id="email">invalid email address"</FormHelperText>
                  )}
                </FormControl>
              </div>
              <div className={classes.fieldGroup}>
                <Controller
                  as={
                    <PhoneInputField
                      required={true}
                      label={t("form.phone")}
                      labelWidth={110}
                      name="phone"
                      onChangeHandler={(value) => setValue("phone", value)}
                      onErrorHandler={(isError) => onErrorHandler(isError)}
                    />
                  }
                  name="phone"
                  control={control}
                  inputRef={register({
                    required: "Required",
                  })}
                />
              </div>
              <div className={classes.btnGroup}>
                <SaveButton
                  label={t("labels.save", { ns: "common" })}
                  type="submit"
                  disabled={!formState.isValid}
                />
                <CancelButton label={t("labels.cancel", { ns: "common" })} onClick={handleModal} />
              </div>
            </form>
          </FormProvider>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default CreateSeller;
